import { frontendURL } from '../../../../helper/URLHelper';
import Index from './Index.vue';
import SettingsWrapper from '../SettingsWrapper.vue';
import { controlPanelRoutes } from '../../masifi/controlPanel/controlPanel.routes';

// Masifi: sección unificada de settings propias ("Masifi Inbox"), admin-only.
// Net-new (rebase-safe). Su registro en settings.routes.js + Sidebar.vue = touchpoints.
export default {
  routes: [
    {
      // R1-RN: ruta visible neutra (antes settings/masifi; la vieja redirige abajo). El nombre de ruta no cambia.
      path: frontendURL('accounts/:accountId/settings/advanced'),
      meta: {
        permissions: ['administrator'],
      },
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'masifi_settings_index',
          component: Index,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/masifi'),
      redirect: to => ({ name: 'masifi_settings_index', params: to.params }),
    },
    // Masifi: Panel de Control (grupo propio del menú; solo se cuelga de este archivo ya registrado).
    ...controlPanelRoutes,
  ],
};
